
import { useEffect, useState } from "react";
import SearchInput from "../SearchInput";
import {Button, Pagination, Table, Tag} from "omoplay";
import {getCustomers} from "../../api/statistics/statistics.api";

const CustomerList = () => {
  const [users, setUsers] = useState([]);
  const [totalCount, setTotalCount] = useState(0)
  const [search, setSearch] = useState("");
  const [page, setPage] = useState(1);
  const [dateRange, setDateRange] = useState();

  useEffect(() => {
    getCustomers(page, search, dateRange?.startDate, dateRange?.endDate).then(({data}) => {
      if (data) {
        setTotalCount(data.totalCount)
        setUsers(data.customers.map(customer => {
          return [
            <div className="flex-center-all h-full"><Tag>{customer.type}</Tag></div>,
            <div className="flex-center-all h-full">
              {
                customer.id
                    ? <div className="text-primary pointer" onClick={() => userDetail(customer.id)}>{customer.name}</div>
                    : <div>{customer.name}</div>
              }
            </div>,
            <div className="flex-align-center h-full">
              <Tag className="text-white" color={customer.gender === "남성" ? "#708090" : "#FFC0CB"}>{customer.gender}</Tag>
            </div>,
            <div className="flex-col flex-center-all h-full gap-2">
              <div>{customer.ageRange}</div>
            </div>,
            <div className="flex-align-center h-full">{customer.email}</div>,
            <div className="flex-col flex-center-all h-full">
              <div>{customer.birthday}</div>
            </div>,
            <div className="flex-col flex-center-all h-full text-center whitespace-pre-line">
              {customer.createdAt}
            </div>,
            <div className="flex-align-center h-full gap-2">
              <Tag color={customer.smsAgreed === "동의" ? 'info' : 'warning'}>SMS {customer.smsAgreed}</Tag>
              <Tag color={customer.emailAgreed === "동의" ? 'info' : 'warning'}>Email {customer.emailAgreed}</Tag>
            </div>,
          ]
        }))
      }
    })
  }, [search, dateRange, page]);

  const handleSearchChange = (search) => {
    setPage(1)
    setSearch(search);
  };

  const headers = [
    { name: "고객 유형", align: "center", width: "120px" },
    { name: "이름", align: "center", width: "100px" },
    { name: "성별", align: "center", width: "80px" },
    { name: "나이", align: "center", width: "100px" },
    { name: "이메일", width: "200px" },
    { name: "생년월일", align: "center", width: "120px" },
    { name: "회원 가입일" ,align: "center", width: "130px" },
    { name: "수신 동의" },
  ];

  function userDetail(id) {
    window.location.href = `/user/detail?id=${id}`
  }

  return (
      <div className="flex-col rounded w-full">
        <div className="flex items-start" style={{marginTop: "35px", gap: "24px"}}>
          <div style={{maxWidth: "405px", width: "405px"}}>
            <div style={{marginBottom: "9px"}}>
              <label className="search-label">검색어</label>
            </div>
            <SearchInput onSubmit={(text) => handleSearchChange(text)} />
          </div>
        </div>
        <div className="flex justify-between items-end" style={{marginTop: "30px", marginLeft: "14px"}}>
          <span className="font-16px">
            총 <span className="text-primary">{totalCount?.toLocaleString()}</span>명
          </span>
        </div>
        <div className="flex-col py-4">
          <Table headers={headers} data={users} />
          <div className="flex justify-center" style={{marginTop: "24px"}}>
            <Pagination pageSize={10} totalCount={totalCount} currentPage={page} onPaging={(page) => setPage(page)} />
          </div>
        </div>
      </div>
  );
};
export default CustomerList;
